import React, {useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';
import {I18n} from 'react-redux-i18n';

import QRCode from 'react-qr-code';
import {withStyles, WithStyles} from '@material-ui/core';

import TabsPanel from '../TabsPanel/TabsPanel';

import {GeneratedTOTPSecretResult} from '../../types/TOTP';
import {generateTOTPSecret} from './action';

import style from './style';
import RenderOrEmpty from '../RenderOrEmpty/RenderOrEmpty';
import Spinner from '../Spinner/Spinner';
import ButtonCopy from '../ButtonCopy/ButtonCopy';

type GenerateTOTPSecretFormProps = WithStyles<typeof style> & {
  isInitial?: boolean;
  // eslint-disable-next-line no-unused-vars
  generatedSecret?: GeneratedTOTPSecretResult;
  // eslint-disable-next-line no-unused-vars
  onSecretGenerated: (result: GeneratedTOTPSecretResult) => void;
};

/**
 * @param isInitial - if true, handles validation as first-time setup with authentication. Optional
 * @param onSecretGenerated - callback on successful secret generation.
 * Passes generated secret with all data as param
 */
function GenerateTOTPSecretForm({
  classes,
  isInitial = false,
  generatedSecret,
  onSecretGenerated,
}: GenerateTOTPSecretFormProps) {
  const dispatch = useDispatch();

  const [activeTabIndex, setActiveTabIndex] = useState(0);

  const qrCodeTab = (
    <div className={classes.secretDisplay__qrContainer}>
      <RenderOrEmpty isShow={!!generatedSecret?.url}>
        <QRCode
          style={{height: 'auto', maxWidth: '100%', width: '100%'}}
          value={generatedSecret?.url ?? ''}
        />
      </RenderOrEmpty>
      <RenderOrEmpty isShow={!generatedSecret?.url}>
        <Spinner />
      </RenderOrEmpty>
    </div>
  );

  const manualSecretTab = (
    <div className={classes.secretDisplay__manualKeyEntering}>
      <RenderOrEmpty isShow={!!generatedSecret?.secret}>
        <p className={classes.manualKeyEntering__secretText}>
          {generatedSecret?.secret ?? ''}
        </p>
        <ButtonCopy
          id="secret"
          content={generatedSecret?.secret ?? ''}
          snackbarMessage={I18n.t('totp.setup.generate.codeCopied')}
        />
      </RenderOrEmpty>
      <RenderOrEmpty isShow={!generatedSecret?.secret}>
        <Spinner />
      </RenderOrEmpty>
    </div>
  );
  const tabs = [
    {
      text: I18n.t('totp.setup.generate.qrCode'),
      content: qrCodeTab,
    },
    {
      text: I18n.t('totp.setup.generate.enterSecret'),
      content: manualSecretTab,
    },
  ];

  useEffect(() => {
    if (generatedSecret) {
      return;
    }
    generateTOTPSecret(
      isInitial,
      (result) => {
        onSecretGenerated(result);
      },
    )(dispatch);
  }, []);

  return (
    <div className={classes.secretDisplay}>
      <p>
        {I18n.t('totp.setup.generate.addSecretInApp')}
      </p>
      <p>
        {I18n.t('totp.setup.generate.scanOrEnter')}
      </p>
      <TabsPanel
        activeTabIndex={activeTabIndex}
        disabled={false}
        handleClickTab={(i) => setActiveTabIndex(i)}
        tabs={tabs}
      />
      <div>{tabs[activeTabIndex]?.content ?? ''}</div>
    </div>
  );
}

export default withStyles(style)(GenerateTOTPSecretForm);
